export default function resolveQuoteRoute({ quote = {}, currentUser = {}, routeParams = {} } = {}) {
  const roleName = currentUser?.role_name
  const paymentApproved = quote.payment_status === 'payment_approved' || quote.payment_status === 'credit_approved'
  const approvedForPurchaseOrder = (quote.quote_status === 'bid_approved' || quote.quote_status === 'buyout') && paymentApproved

  if (roleName === 'admin') {
    if (approvedForPurchaseOrder) {
      return {
        name: 'purchaseOrder',
        params: { quoteId: quote.id },
      }
    }

    if (quote.quote_status === 'bidding') {
      return {
        name: 'firstRound',
        params: { quoteId: quote.id },
        query: { branchId: routeParams.id },
      }
    }
  }

  if (roleName === 'auctioneer' || roleName === 'supplier_admin') {
    if (approvedForPurchaseOrder) {
      return {
        name: 'purchaseOrder',
        params: { quoteId: quote.id },
      }
    }

    if (quote.quote_status === 'bidding') {
      return {
        name: 'firstRound',
        params: { quoteId: quote.id },
        query: { branchId: routeParams.id },
      }
    }
  }

  if (quote.is_published && (quote.quote_status === 'pending' || quote.quote_status === 'awaiting_customer_response')) {
    return { name: 'prequote', params: { quoteId: quote.id } }
  }

  if (quote.quote_status === 'pending') {
    return {
      name: 'addProductsToQuote',
      params: { quoteId: quote.id },
    }
  }

  if (quote.quote_status === 'buyout') {
    return {
      name: 'checkout',
      params: { quoteId: quote.id },
    }
  }

  if (quote.quote_status === 'bidding') {
    return {
      name: 'auctionInProgress',
      params: { quoteId: quote.id },
    }
  }

  if (quote.quote_status === 'awaiting_bid_approval') {
    return {
      name: 'clientQuote',
      params: { id: quote.id },
    }
  }

  if (quote.quote_status === 'bid_approved') {
    return {
      name: 'checkout',
      params: { quoteId: quote.id },
    }
  }

  return {
    name: 'checkout',
    params: { quoteId: quote.id },
  }
}
